import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle } from "lucide-react";
import { api } from "@/lib/api";

export function ReadinessMeter({ compact = false }) {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/readiness").then((res) => setR(res.data)); }, []);
  if (!r) return <div className="h-40 bg-white border border-slate-200 rounded-lg animate-pulse" />;
  const color = r.ready ? "#10b981" : r.score >= 60 ? "#f59e0b" : "#94a3b8";
  const C = 2 * Math.PI * 52;
  return (
    <div className={`rounded-lg border p-6 md:p-8 ${r.ready ? "bg-emerald-50 border-emerald-300" : "bg-white border-slate-200"}`} data-testid="readiness-meter">
      <div className="flex flex-col md:flex-row gap-8 md:items-center">
        <div className="relative h-32 w-32 shrink-0">
          <svg viewBox="0 0 120 120" className="h-32 w-32 -rotate-90">
            <circle cx="60" cy="60" r="52" stroke="#e2e8f0" strokeWidth="10" fill="none" />
            <circle cx="60" cy="60" r="52" stroke={color} strokeWidth="10" fill="none" strokeLinecap="round"
              strokeDasharray={C} strokeDashoffset={C * (1 - r.score / 100)} style={{ transition: "stroke-dashoffset 900ms ease-out" }} />
          </svg>
          <div className="absolute inset-0 grid place-items-center">
            <span className="font-display text-3xl font-extrabold text-slate-900" data-testid="readiness-score">{r.score}%</span>
          </div>
        </div>
        <div className="flex-1">
          <div className="eyebrow mb-1" style={{ color: r.ready ? "#047857" : undefined }}>Ready-to-Apply score</div>
          <h3 className="font-display text-2xl font-extrabold text-slate-900">
            {r.ready ? "Your business is ready to apply" : `Your business is ${r.score}% ready to apply`}
          </h3>
          {!compact && (
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
              {r.parts.map((p) => (
                <Link key={p.key} to={p.to} data-testid={`readiness-part-${p.key}`} className="flex items-center gap-2 text-sm hover:bg-slate-50 rounded px-2 py-1.5 transition-colors">
                  {p.pct >= 1 ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <Circle className="h-4 w-4 text-slate-300" />}
                  <span className="flex-1 text-slate-700">{p.label}</span>
                  <span className="font-mono text-xs text-slate-500">{Math.round(p.pct * 100)}%</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
